var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHouse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.4842 2.17812C10.2029 1.94062 9.79353 1.94062 9.51228 2.17812L1.26228 9.17812C0.946657 9.44688 0.909157 9.91875 1.17478 10.2344C1.44041 10.55 1.91541 10.5875 2.23103 10.3219L2.99978 9.67188V15.5C2.99978 16.8813 4.11853 18 5.49978 18H14.4998C15.881 18 16.9998 16.8813 16.9998 15.5V9.67188L17.7654 10.3219C18.081 10.5906 18.556 10.55 18.8217 10.2344C19.0873 9.91875 19.0498 9.44375 18.7342 9.17812L10.4842 2.17812ZM4.49978 15.5V8.4L9.99978 3.73438L15.4998 8.4V15.5C15.4998 16.0531 15.0529 16.5 14.4998 16.5H12.9998V11.75C12.9998 11.0594 12.4404 10.5 11.7498 10.5H8.24978C7.55916 10.5 6.99978 11.0594 6.99978 11.75V16.5H5.49978C4.94666 16.5 4.49978 16.0531 4.49978 15.5ZM8.49978 16.5V12H11.4998V16.5H8.49978Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "72495886639fe40db9174c6b03d59af2.svg";